const cityToggleConfig = cityId => ({
  originalDocumentUploadCities: ['berlin', 'paris', 'london'].includes(cityId),
  isNoDepositSupported: ['milan', 'rome'].includes(cityId),
  isSuperListerSupported: !['paris'].includes(cityId),
  isFreeCancellationSupported: true
});

export default cityToggleConfig;
